// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f9299b35","455":"0ab5b27a","551":"079b9a9d","644":"b71966f3","830":"d6f25fbd"}[chunkId] + ".chunk.js";
};